import _ from "lodash";
import { INewsTranslation } from "../domain/models/newsTranslation";
import { SimpleMapper } from "./SimpleMapper";
import { NewsTranslationDTO } from "../domain/models/dto/NewsDTO";

export class NewsTranslationMapper extends SimpleMapper<
    INewsTranslation,
    NewsTranslationDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "content",
        "shortContent",
        "languageCode",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "newsId",
        "availableLangs",
    ];

    fromDTO(dto: NewsTranslationDTO): INewsTranslation {
        if (!dto) {
            return null;
        }
        const result = super.fromDTO(dto);
        result.languageCode = !_.isEmpty(dto.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }

    toDTO(model: INewsTranslation): NewsTranslationDTO {
        if (!model) {
            return null;
        }
        const result = super.toDTO(model);
        result.languageCode = !_.isEmpty(model.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }
}
